import { VoucherCategory } from '@debbie/common/dist/economy/vouchers/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import VoucherTypeSelect from './VoucherTypeSelect.js';
const BILLING_CATEGORIES = [VoucherCategory.FEE, VoucherCategory.DISBURSEMENT];
/** Searchable single-select for billing voucher types (fees and disbursements) */
const BillingVoucherTypeSelect = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(VoucherTypeSelect, { ...props, categories: props.categories ?? BILLING_CATEGORIES, placeholder: props.placeholder ?? lang.voucherTypeSelect.selectBillingVoucherType }));
};
export default BillingVoucherTypeSelect;
//# sourceMappingURL=BillingVoucherTypeSelect.js.map